// New Idea..
// Build json for all domains and ship all of it.
// fetch(`/${APP_VERSION}_${window.hostname}.json`);
// can be typechecked with the current build?
// could be fetched directly in the html head easily.
// should we hash the filename as well?
// could fallback to hard coded production values.
// wont easily expose hidden config values like configcat key.
// production can be hard coded and skip fetching.
//
import { getFeatureFlag, isString } from "@sinch/feature-flags";

type AppEnv = "production" | "staging" | "dev";
export type AuthConfig =
  | { type: "kc" | "mm"; url?: string }
  | { type: "oidc"; url?: string; aud?: string };
const isAppEnv = (x: unknown): x is AppEnv =>
  ["production", "staging", "dev"].includes(x as string);

declare const SHELL_ENV: {
  APP_VERSION: string;
  AUTH_CONFIG: AuthConfig;
  API_STRATEGY: "engage" | "mm" | "cop";
  CONFIGCAT_SDK_KEY: string;
  DATADOG_APPLICATION_ID: string;
  DATADOG_CLIENT_TOKEN: string;
  API_BASE_URL: string;
  NEXTGEN_API_URL: string;
  ENGAGE_MFE_BASE_DOMAIN: string;
  SOCKET_HOST?: string; // Can potentially move into configcat
  CAMPAIGNS_HIVE_PROXY?: string;
  MFE_UPLOAD_BUCKET?: string;
  COMMIT_HASH: string;
};

export const APP_VERSION = SHELL_ENV.APP_VERSION;
export const COMMIT_HASH = SHELL_ENV.COMMIT_HASH;

const hash = location.hash.slice(1);
const params = new URLSearchParams(hash);
/** Returns the value of hash parameter with name `name`. */
const getParam = (name: string): string | null => {
  const val = params.get(name) ?? sessionStorage.getItem(name);
  if (val) sessionStorage.setItem(name, val);
  return val;
};

// Override to get env specific behaviours.
const _env = getParam("_env");

// Override to get hostname specific config. (TODO: This must move to index.html to be able to fetch correct config.)
//const _hostname = getParam("_hostname");

const host = location.hostname.toLowerCase();
// build time env dependent...
export const APP_ENV: AppEnv = isAppEnv(_env)
  ? _env
  : ["localhost", "127.0.0.1"].includes(host)
  ? "dev"
  : "production";

export const ENGAGE_MFE_BASE_DOMAIN = SHELL_ENV.ENGAGE_MFE_BASE_DOMAIN;
export const DATADOG_APPLICATION_ID = SHELL_ENV.DATADOG_APPLICATION_ID;
export const DATADOG_CLIENT_TOKEN = SHELL_ENV.DATADOG_CLIENT_TOKEN;
export const AUTH_CONFIG = SHELL_ENV.AUTH_CONFIG;
export const API_BASE_URL = SHELL_ENV.API_BASE_URL;
export const CONFIGCAT_SDK_KEY = SHELL_ENV.CONFIGCAT_SDK_KEY;
export const SOCKET_HOST = SHELL_ENV.SOCKET_HOST;
export const CAMPAIGNS_HIVE_PROXY = SHELL_ENV.CAMPAIGNS_HIVE_PROXY;
export const MFE_UPLOAD_BUCKET = SHELL_ENV.MFE_UPLOAD_BUCKET;
export const API_STRATEGY = SHELL_ENV.API_STRATEGY;

export const getMessageMediaApiUrlMiddleware = () =>
  getFeatureFlag(
    "messageMediaApiUrlMiddleware",
    isString,
    SHELL_ENV.API_BASE_URL
  );
export const getMessageMediaApiUrl = () =>
  getFeatureFlag("messageMediaApiUrl", isString, SHELL_ENV.NEXTGEN_API_URL);
export const getOnesaasApiUrlAuth = () =>
  getFeatureFlag("onesaasApiUrlAuth", isString, SHELL_ENV.AUTH_CONFIG.url);
